<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="title-header">
              Where is my Member Number or Check-In Code?
            </div>
            <a class="btn btn-link pull-right close-modal" @click="$emit('close')"><i class="fa fa-close"></i></a>
          </div>
          <div class="modal-body">
            <div class="row">
              <h3 class="title-24">1. Membership Agreement Number</h3>
                <div class="text-24 font-bold">
                  <p>
                    This is located on page 1 of your Membership Agreement document.
                  </p>
                </div>
            </div>
            <div class="row">
              <div class="card-img-container col-md-12">
                <img src="../assets/blank-agmt.jpg" class="full-img" alt="Sample Agreement">
              </div>
            </div>
            <div class="row martop10">
              <h3 class="title-24">2. Check-In Code</h3>
              <div class="text-24 font-bold">
                <p>
                  This is a 10 digit number you provided to access the clubs.
                </p>
              </div>
              <div class="text-24 martop10">
                <p>
                  If you need assistance with your member number or check-in code, please visit your club.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

  export default {
    mounted () {
      document.addEventListener('keyup', this.listener)
    },
    beforeDestroy () {
      document.removeEventListener('keyup', this.listener)
    },
    data () {
      return {
        listener: (evt) => {
          if (evt.keyCode === 27) {
            this.$emit('close')
          }
        }
      }
    }
  }

</script>
<style lang="scss" scoped="true">
  @import '../../node_modules/bootstrap-sass/assets/stylesheets/bootstrap/_variables.scss';

  .font-bold {
    font-weight: bold;
  }

  .martop10 {
    margin-top: 10px;
  }

  .container-24 {
    h3.title-24 {
      color: #25799d;
    }
  }

  .modal-mask .modal-wrapper .modal-container {
    max-width: 800px;
    .modal-header {
      font-weight: bold;
    }

    .modal-body {
      margin: 0 0 10px 0;
      padding: 0 25px 15px 25px;
      max-height: 500px;
    }
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {
    .modal-mask {
      .modal-wrapper .modal-container {
        width: 80%;
        top: 20%;
        margin: 15% auto;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/HelperModal.vue